import { InmateSubscription } from '@reliance/types/models/InmateSubscription';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import ConfirmModal from '../common/dialogs/ConfirmModal';
import { formatCurrency } from '../format/Currency';
import { formatDate } from '../format/DateTime';
import { Inmate } from '@reliance/types/models/Inmate';
import BaseHtmlTable from '../table/BaseHtmlTable';
import { PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';

type TableProps = {
  subscriptions: PaginatedResponse<InmateSubscription>
  inmate?: Inmate
  onStop?(subscription: InmateSubscription): Promise<any>
}

const Table: React.FC<TableProps> = (props) => {
  const { subscriptions, inmate } = props;

  const [showCancel, setShowCancel] = useState<InmateSubscription>(null);

  if (subscriptions == null) {
    return null;
  }

  let columns = [
    { key: 'inmate', name: 'Inmate' },
    { key: 'subscription', name: 'Subscription' },
    { key: 'cost', name: 'Cost' },
    { key: 'dateStarted', name: 'Started' },
    { key: 'dateFinished', name: 'Stopped' },
    { key: 'dateLastCharged', name: 'Last Charge' },
    { key: 'dateNextCharge', name: 'Next Charge' },
    { key: 'options', name: 'Options' }
  ];

  // If we were sent a specific inmate, we don't need that column
  if (inmate) {
    columns = columns.filter(c => c.key != 'inmate');
  }

  // Massage the reference material into applicable/usable columns
  const rows = subscriptions.data.map(subscription => ({
    id: subscription.id,
    inmate: (
      <Link to={`/inmates/view/${subscription.inmate.id}`}>
        {subscription.inmate.firstName} {subscription.inmate.lastName} (#{subscription.inmate.account})
      </Link>
    ),
    dateStarted: formatDate(subscription.dateStarted),
    dateFinished: subscription.dateFinished ? formatDate(subscription.dateFinished) : '',
    dateLastCharged: subscription.dateLastCharged ? formatDate(subscription.dateLastCharged) : '',
    dateNextCharge: subscription.dateFinished == null ? formatDate(subscription.dateNextCharge) : '',
    subscription: subscription.subscription.type,
    cost: `${formatCurrency(subscription.subscription.cost)} (Interval: ${subscription.subscription.interval})`,
    options: (
      <div>
        {props.onStop && subscription.dateFinished == null &&
          <Button onClick={() => setShowCancel(subscription)} size="sm" variant="outline-danger">Cancel Subscription</Button>
        }
        <ConfirmModal
          key={`cancel-subscription-${subscription.id}`}
          show={showCancel == subscription}
          title="Cancel inmate subscription"
          acceptText="Cancel Subscription"
          onAccept={() => props.onStop(subscription)}
          onClose={() => setShowCancel(null)}>
          Are you sure you want to cancel the "{subscription.subscription.type}" subscription?
        </ConfirmModal>
      </div>
    )
  }));

  return (
    <BaseHtmlTable
      columns={columns}
      rows={rows}
      perPage={1000}
      />
  );
}

export default Table;